import { MouseEvent, PropsWithChildren, forwardRef, memo } from 'react';

type DivProps = {
  className?: string;
  dangerouslySetInnerHTML?: { __html: string };
  style?: any;
  id?: string;
  dataTestId?: string;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  forceRender?: boolean;
};

const Div = (
  {
    children,
    className,
    dataTestId,
    style,
    dangerouslySetInnerHTML,
    forceRender,
    ...restProps
  }: PropsWithChildren<DivProps>,
  ref: React.Ref<HTMLDivElement>,
) => {
  if (!children && !dangerouslySetInnerHTML && !forceRender) return null;
  return (
    <div
      ref={ref}
      data-testid={dataTestId}
      className={className}
      style={style}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default memo(forwardRef(Div));
